import * as yup from 'yup';
import { locales } from '@/features/validation/locales';
import { genericStoreFactory } from '@/utils/genericStoreFactory/genericStoreFactory';
import { contractSchema } from '@/features/Sparten/hau/schema/contractSchema';

yup.setLocale(locales);

export type ContractStore = yup.Asserts<typeof contractSchema>;

export const useHauContractStore = genericStoreFactory(
  () => contractSchema.getDefault() as ContractStore,
  'HauContractStore',
);
